import { CUSTOM_THEMES } from './custom-themes.constant';
import Aura from '@primeng/themes/aura';

export interface Theme {
  name: string;
  id: string;
}

const customThemes: Theme[] = CUSTOM_THEMES.map((theme) => ({
  name: theme.name,
  id: theme.id,
}));

export const ALL_THEMES: Theme[] = [...customThemes];

export function getThemePalette(themeId: string | null, isDark: boolean = false): any {
  if (!themeId) {
    return null;
  }

  const customTheme = CUSTOM_THEMES.find((t) => t.id === themeId);
  if (customTheme) {
    return isDark ? customTheme.primitive_dark : customTheme.primitive;
  }

  // Fallback for default theme if it's an Aura theme
  if (Aura.primitive[themeId]) {
    return Aura.primitive[themeId];
  }

  return null;
}
